export const CONFIRMATION_MODAL = {
  TITLES: {
    highSensitive: 'High sensitive information',
    delete: 'Confirm deletion',
  },

  DESCRIPTIONS: {
    highSensitive: 'Are you sure to send this information?',
    delete: 'Are you sure you want to permanently remove this item?',
  },

  CONFIRMS: {
    highSensitive: {
      accept: 'Yes',
      cancel: 'No',
    },
    delete: {
      accept: 'Delete',
      cancel: 'Cancel',
    },
  },
};
